import HttpClient from '../../services/HttpCilent';
import { PhysicalTakeHeaderDetail, PhysicalTakeHeader2 } from './Data/Data';

export const getPhysicTakeHeaders = (data) => {
    return new Promise((resolve) => {
        let response;
        HttpClient.get('/api/physicTakeHeaders/getPhysicTakeHeadersByRestaurant?'
            + 'status=' + data.status
        ).then(resp => {
            if (resp.data.response) {
                response = {
                    status: resp.data.response,
                    data: resp.data.data,
                    headers: (resp.data.headers.length) ? resp.data.headers : PhysicalTakeHeader2()
                };
            } else {
                response = {
                    status: resp.data.response,
                    messages: (resp.data.messages.length) ? resp.data.messages : [resp.data.alert],
                };
            }
            resolve(response);
        }).catch(() => {
            const data = {
                status: false,
                messages: ['Ocurrio un error de comunicacion con el servidor comuniquese con soporte'],
            };
            resolve(data);
        })
    })
}

export const getPhysicTakeDetails = (data) => {
    return new Promise((resolve) => {
        let response;
        HttpClient.get('/api/physicTakeDetails/getAll?id_physic_take=' + data.physicTakeHeaderCode
            + '&article_name=' + data.nameArtcicle
            + '&article_code=' + data.codeArticle
            + ((data.area)? '&area=' + data.area : '')
            + ((data.groupArticle)? '&article_group=' + data.groupArticle : '')
            +  ((data.movements !== 2)? '&movement='+data.movements : '')
            + '&page=' + data.page
        ).then(resp => {
            if (resp.data.response) {
                response = {
                    status: resp.data.response,
                    data: formatDetail(resp.data.data),
                    headers: (resp.data.headers.length) ? resp.data.headers : PhysicalTakeHeaderDetail(),
                    offline: false
                };
            } else {
                response = {
                    status: resp.data.response,
                    messages: (resp.data.messages.length) ? resp.data.messages : [resp.data.alert],
                    offline: (resp.data.offline)? resp.data.offline : false
                };
            }
            resolve(response);
        }).catch(() => {
            const data = {
                status: false,
                messages:  ['Ocurrió un error de comunicación con el servidor, verifique su conexión a internet o comuníquese con soporte'],
                offline: true
            };
            resolve(data);
        })
    })
}

export const updateAmountPhysicalTake = (data) => {
    return new Promise((resolve) => {
        HttpClient.put('/api/physicTakeDetails/' + data.id_artcicle + '?type=basic'
            , data
        ).then(resp => {
            let response = {
                status: resp.data.response,
                messages: (resp.data.messages.length) ? resp.data.messages : [resp.data.alert],
            };
            resolve(response);
        }).catch(() => {
            const data = {
                status: false,
                messages: ['Ocurrio un error de comunicacion con el servidor comuniquese con soporte'],
            };
            resolve(data);
        })
    })
}

    
export const getAreas = () =>{
    return new Promise((resolve) => {
        let data;
        HttpClient.get('/api/areasRestaurants/getAreasByRestaurant').then(resp => {
            if(resp.data.response){
                data = {
                    status: resp.data.response,
                    data: resp.data.data
                };
            } else {
                data = {
                    status: resp.data.response,
                    messages: (resp.data.messages.length)? resp.data.messages : [resp.data.alert],
                    data: []
                };
            }
            resolve(data); 
        }).catch(() => {
            const data = {
                status: false,
                messages: ['Ocurrio un error de comunicacion con el servidor comuniquese con soporte']
            };
            resolve(data);
        })
    })
}

function formatDetail(response){
    let data = {};
    response.forEach(function(element) {
        if(data[element.articleCode.trim()] === undefined){
            let item = {};
            let area = {};
            item['name'] = element.articleCode.trim() +' - '+ element.name;
            item['unit'] = element.unitInventory;
            item['article_code'] = element.articleCode.trim();
            item['article_name'] = element.name;
            item['group_name'] = element.nameGroup;
            item['article_group'] = element.articleGroup;
            item['area'] = [];
            item['total'] = element.physicQuantity;
            area['area_code'] = element.areaCode;
            area['area_name'] = element.areaName;
            area['id_article'] = element.warehouseArticleCode;
            area['quantity'] = element.physicQuantity;
            area['system_quantity'] = element.systemQuantity;
            item['area'].push(area);
            data[element.articleCode.trim()] = item;
        } else {
            let area = {}; 
            area['area_code'] = element.areaCode;
            area['area_name'] = element.areaName;
            area['id_article'] = element.warehouseArticleCode;
            area['quantity'] = element.physicQuantity;
            area['system_quantity'] = element.systemQuantity;
            data[element.articleCode.trim()].area.push(area);
            data[element.articleCode.trim()].total += element.physicQuantity;
        }
    });

    return data;
}

export const getArticleGroups = (physicTakeHeaderCode) => {
    return new Promise((resolve) => {
        let response;
        HttpClient.get('/api/physicTakeDetails/getGroupByPhysicTake?id_physic_take=' + physicTakeHeaderCode
        ).then(resp => {
            if (resp.data.response) {
                response = {
                    status: resp.data.response,
                    data: resp.data.data,
                    headers: (resp.data.headers.length) ? resp.data.headers : []
                };
            } else {
                response = {
                    status: resp.data.response,
                    messages: (resp.data.messages.length) ? resp.data.messages : [resp.data.alert],
                };
            }
            resolve(response);
        }).catch(() => {
            const data = {
                status: false,
                messages: ['Ocurrio un error de comunicacion con el servidor comuniquese con soporte'],
            };
            resolve(data);
        })
    })
}

export const getAreasByRestaurant = () => {
    return new Promise((resolve) => {
        let response;
        HttpClient.get('/api/areasRestaurants/getAreasByRestaurant'
        ).then(resp => {
            if (resp.data.response) {
                response = {
                    status: resp.data.response,
                    data: resp.data.data,
                    headers: (resp.data.headers.length) ? resp.data.headers : []
                };
            } else {
                response = {
                    status: resp.data.response,
                    messages: (resp.data.messages.length) ? resp.data.messages : [resp.data.alert],
                };
            }
            resolve(response);
        }).catch(() => {
            const data = {
                status: false,
                messages: ['Ocurrio un error de comunicacion con el servidor comuniquese con soporte'],
            };
            resolve(data);
        })
    })
}

export const updateAmountPhysicalTakeArray = (data) => {
    return new Promise((resolve) => {
        HttpClient.put('/api/physicTakeDetails/v2?type=array'
            , data
        ).then(resp => {
            let response = {
                status: resp.data.response,
                messages: (resp.data.messages.length) ? resp.data.messages : [resp.data.alert],
                offline: (resp.data.offline)? resp.data.offline : false
            };
            resolve(response);
        }).catch(() => {
            const data = {
                status: false,
                messages: ['No se pudo guardar la información, puede seguir funcionando sin conexión y, una vez que se restaure la conexión a internet, se llevará a cabo el almacenamiento automático de la misma.'],
                offline: true
            };
            resolve(data);
        })
    })
}